import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import { lightenDarkenColor } from "../../../../../../../utils";
import AuthenticatedUserToolBar from "../../../../../../../components/ToolBar/components/AuthenticatedUserToolBar";

import LearningLabItem from "../../components/LearningLabItem";
import ShareOptions from "./ShareOptions";

import { Route } from "react-router-dom";
import {
  getHumanDiffDate,
  copyTextToClipboard,
} from "../../../../../../../../Util";
import {
  recordLearningLabViewCount,
  likeLearningLabItem,
  shareLearningLabItem,
} from "../../../../../../../../API";
import { message } from "antd";

import BottomSheetOptions from "../../../../../../../components/BottomSheetOptions";
import "./styles.css";

function shareToOptions() {
  const options = [
    {
      icon: (
        <svg fill="#62d2c4" width="24" height="24" viewBox="0 0 1024 1024">
          <path d="M63.7,845C143.2,629.2,476,604.3,598,602.5v115.8c0,24.3,28.6,37.5,47.2,21.9l304.7-255.4   c13.6-11.4,13.7-32.4,0.1-43.8L645.1,185.7c-18.6-15.6-47.1-2.4-47.1,21.9v114.6C461,325.4,63.7,374.8,63.7,845z" />
          <path d="M83.1,850.3c0.9-2.5,1.9-5,2.9-7.5c0.3-0.7,0.6-1.4,0.9-2.1c0.1-0.2-1.8,4.1-0.9,2.1    c0.6-1.4,1.2-2.8,1.8-4.2c2.2-5,4.6-9.9,7.2-14.7c5-9.5,10.6-18.7,16.7-27.5c1.4-2,2.8-3.9,4.2-5.8c0.8-1,1.5-2.1,2.3-3.1    c0.7-1,2.4-2.7-1.1,1.4c0.5-0.6,0.9-1.2,1.4-1.7c3.3-4.2,6.7-8.2,10.2-12.2c7-7.9,14.5-15.5,22.4-22.6c3.9-3.6,8-7.1,12.1-10.5    c2-1.6,4-3.3,6-4.9c0.4-0.3,0.9-0.7,1.3-1c1.7-1.4-2.1,1.6-1.9,1.4c1.2-0.9,2.3-1.8,3.5-2.7c8.6-6.4,17.5-12.5,26.7-18.2    c18.4-11.5,37.6-21.5,57.4-30.3c2.4-1.1,4.9-2.1,7.3-3.2c4.4-1.9-3.3,1.3,0,0c1.4-0.6,2.8-1.2,4.2-1.7c5.1-2.1,10.3-4.1,15.4-6    c10.4-3.9,20.8-7.5,31.3-10.8c20.7-6.6,41.7-12.2,62.9-17c20.5-4.7,41.1-8.6,61.8-11.9c5-0.8,10.1-1.6,15.1-2.3    c2.4-0.3,4.8-0.7,7.2-1c0.7-0.1,1.4-0.2,2-0.3c0.4-0.1-5,0.6-2.8,0.4c1.4-0.2,2.7-0.4,4.1-0.5c9.6-1.2,19.1-2.3,28.7-3.3    c31.7-3.3,63.5-5.2,95.4-6c3.1-0.1,6.2-0.1,9.3-0.2c-6.7-6.7-13.3-13.3-20-20c0,38.5-0.6,77,0,115.4c0.3,21.7,13.5,39.4,33.8,46.6    c16.9,6,34.5,0.5,47.8-10.5c6.8-5.6,13.5-11.4,20.3-17c34.9-29.2,69.7-58.5,104.6-87.7c40.4-33.9,80.8-67.7,121.2-101.6    c14-11.8,28.1-23.6,42.1-35.3c5.7-4.8,11.6-9.3,17.1-14.4c19.7-18.4,19.8-51.8,0-70.2c-1.6-1.5-3.4-2.9-5.1-4.3    c-10-8.4-20-16.7-30-25.1c-37.8-31.7-75.6-63.4-113.4-95c-38.7-32.4-77.3-64.8-116-97.2c-11.4-9.6-22.9-19.2-34.3-28.7    c-2.2-1.9-4.4-3.7-6.7-5.6c-13.3-11-30.9-16.5-47.8-10.5c-20.3,7.2-33.5,25-33.8,46.6c-0.1,7,0,14,0,21c0,25.6,0,51.2,0,76.8    c0,5.5,0,11,0,16.4c6.7-6.7,13.3-13.3,20-20c-37.1,0.8-74.2,4.6-110.9,10.7c-46.4,7.7-92.2,19.9-135.8,37.5    C299,371.7,250,399.9,207,437c-46.5,40.1-84.3,90.4-110.3,146c-33.6,71.8-48.9,150.3-52.2,229.2c-0.5,11-0.7,21.9-0.7,32.9    c0,10.5,9.2,20.5,20,20c10.8-0.5,20-8.8,20-20c0-21.9,0.9-43.9,2.8-65.7c0.4-5.1,0.9-10.1,1.5-15.2c0.2-2.3,0.5-4.5,0.8-6.8    c0.2-1.3,0.3-2.7,0.5-4c0.1-0.9,0.2-1.8,0.3-2.7c0.3-2.2,0.2-1.8-0.2,1.3c-0.9-0.3,4.1-26,4.6-28.6c6.5-35.2,16.2-69.9,29.7-103.1    c0.6-1.5,3.6-8.1,0.8-1.9c0.8-1.7,1.5-3.4,2.2-5.1c1.8-4,3.6-8,5.5-12c3.4-7.1,6.9-14.1,10.7-21c7.4-13.6,15.5-26.9,24.3-39.6    c2.1-3,4.2-6,6.4-9c1-1.3,2-2.7,3-4c0.6-0.8,1.2-1.6,1.8-2.4c2.8-3.7-1.3,1.6-0.4,0.5c4.5-5.8,9.1-11.5,13.9-17    c9.4-10.8,19.3-21.1,29.7-30.9c9.9-9.3,20.6-17.6,30.9-26.5c-5.5,4.7-0.4,0.3,1-0.8c1.2-0.9,2.4-1.8,3.6-2.7    c2.9-2.2,5.8-4.3,8.8-6.3c5.4-3.8,10.8-7.4,16.4-11c22-14.1,45.2-26.4,69.1-36.9c1.3-0.6,2.6-1.1,3.9-1.7c0.8-0.3,1.6-0.7,2.3-1    c3.1-1.3-4.3,1.8-2.1,0.9c3-1.2,6-2.5,9-3.7c5.8-2.3,11.6-4.5,17.5-6.6c11.3-4.1,22.8-7.8,34.4-11.3c22-6.5,44.3-11.8,66.8-16    c10.3-1.9,20.7-3.7,31.1-5.2c1.1-0.2,2.2-0.3,3.3-0.5c0.7-0.1,1.3-0.2,2-0.3c2.8-0.4-3.8,0.5-3.3,0.4c2.6-0.4,5.2-0.7,7.8-1    c4.6-0.6,9.3-1.1,13.9-1.6c16.6-1.7,33.2-2.9,49.9-3.5c3.4-0.1,6.8-0.2,10.2-0.3c10.8-0.2,20-9,20-20c0-37.9-0.2-75.8,0-113.7    c0-0.7,0-1.5,0-2.2c-0.1-3.4,0,1.2-0.3,1.6c0.5-0.6,0.6-2.7,0.8-3.5c0.2-0.6,0.7-1.6,0.8-2.2c-1.3,3-1.5,3.6-0.6,1.7    c0.3-0.5,0.6-1,0.9-1.5c1.3-2.4,1.9-0.5-0.8,0.9c0.4-0.2,1.1-1.2,1.5-1.6c0.7-0.7,1.8-1.4,2.4-2.2c-2.5,3.1-2.9,2-1.4,1.2    c0.6-0.3,2.5-1.1,2.9-1.6c-0.2,0.3-4.8,1.6-1.7,0.7c0.9-0.3,1.7-0.6,2.6-0.8c0.5-0.1,1.1-0.3,1.6-0.4c2.1-0.4,1.4-0.3-2,0.3    c0.5,0.1,1.6-0.1,2.2-0.1c2.6,0,3.1,1.3-0.9-0.4c1.1,0.4,4.5,1.6,5.5,1.5c-0.6,0.1-4.3-2.3-1.6-0.6c0.7,0.5,1.8,1.3,2.6,1.6    c1.9,0.7-1.5-1.2-1.5-1.2c0.4,0.5,1,0.8,1.5,1.2c7.9,6.7,15.9,13.4,23.9,20c34.8,29.2,69.6,58.4,104.4,87.5    c39.2,32.9,78.4,65.7,117.6,98.6c19.1,16,38.5,31.6,57.2,48c0.7,0.6,1.4,1.2,2.1,1.9c0.3,0.3,0.6,0.7,0.9,1    c1.4,1.7,1.2,1.4-0.7-0.9c0.1,0,1.5,2.4,1.4,2.3c2.2,3.3-0.4-2.9-0.2-0.6c0.1,0.9,0.6,2.2,0.9,3.1c1.2,3.9,0.4-3.3-0.1-0.9    c-0.1,0.4-0.2,4.3,0,4.5c-0.4-0.3,1.2-5,0.1-1.5c-0.1,0.2-1,3.7-1.1,3.7c-0.4-0.2,2.5-4.4,0.4-1.2c-0.2,0.4-0.4,0.8-0.7,1.1    c-1,1.4-0.9,1.5,0.1,0.2c0.3-0.3,0.5-0.6,0.8-1c-0.6,0.7-1.2,1.4-1.8,2c-0.7,0.7-1.3,1.3-2,1.9c0,0-0.1,0.1-0.1,0.1    c-1.7,1.5-3.5,2.9-5.3,4.4c-10.2,8.6-20.4,17.1-30.6,25.7c-36.9,30.9-73.7,61.8-110.6,92.7c-38,31.9-76,63.7-114,95.6    c-11.6,9.7-23.3,19.5-34.9,29.2c-2.7,2.3-5.4,4.5-8.1,6.8c-0.3,0.3-0.8,0.6-1.1,0.9c1.7-2,3.1-2,1-0.9c-0.7,0.4-1.5,0.8-2.1,1.2    c-3.3,2.1,3.4-0.7,1-0.4c-0.9,0.1-1.8,0.6-2.7,0.8c-0.6,0.1-4.4,1-0.7,0.2c3.5-0.7,0.2-0.1-0.7-0.1c-0.4,0-1.7-0.2-2.2-0.1    c3.5,0.5,4.2,0.6,2,0.3c-0.7-0.1-1.4-0.3-2.1-0.5c-0.7-0.2-1.4-0.5-2.1-0.7c-3.6-1.1,3.1,2,1.3,0.5c-0.6-0.5-1.7-1-2.4-1.4    c-2.7-1.4,1.1,0.8,1.4,1.2c-0.7-0.9-2.9-3.3-3.9-3.8c2.6,1.3,2.2,3.2,0.5,0.4c-1.3-2.1-0.3-3.5,0,0.7c-0.1-0.9-1.1-4.9-1.6-5.7    c1.5,2.3,0.3,4,0.3,1.6c0,0.2,0-0.9,0-1.3c0-0.5,0-1,0-1.5c0-8,0-16.1,0-24.1c0-25,0-50,0-74.9c0-5.1,0-10.1,0-15.2    c0-10.7-9.2-20.2-20-20c-31.1,0.4-62.2,2.1-93.2,5c-41.8,3.9-83.6,9.8-124.7,18.5c-43.5,9.2-86.5,21.5-127.5,38.6    c-43.1,18-83.8,40.4-119.7,70.5C99,743.7,70.3,779.7,52.4,820.5c-2.8,6.3-5.4,12.7-7.8,19.2c-3.6,9.8,4.1,22.3,14,24.6    C69.9,866.9,79.2,860.8,83.1,850.3z" />
        </svg>
      ),
      label: "Share to RiseUp forums",
    },
    {
      icon: (
        <svg fill="#1da1f2" height="24" width="24" viewBox="0 0 24 24">
          <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z" />
        </svg>
      ),
      label: "Share To Twitter",
    },
    {
      icon: (
        <svg fill="#2d88ff" height="24" width="24" viewBox="0 0 36 36">
          <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z" />
          <path
            fill="#fff"
            d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"
          />
        </svg>
      ),
      label: "Share To Facebook",
    },
    {
      icon: (
        <svg
          stroke="#faad14"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
      ),
      label: "Copy Article Link",
    },
  ];

  if (navigator.share && typeof navigator.share === "function") {
    options.splice(3, 0, {
      icon: (
        <svg fill="#e79792" height="24" width="24" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" />
        </svg>
      ),
      label: "Share",
    });
  }

  return options;
}

function ReadArticle({
  history,
  location,
  match,
  activeTab,
  authUser,
  authToken,
}) {
  const [selectedItem, setSelectedItem] = useState({});
  const [contentType, setContentType] = useState("");
  const [liked, setLiked] = useState(null);
  const [likeCount, setLikeCount] = useState(-1);
  const [shareCount, setShareCount] = useState(-1);
  const [viewingFull, setViewingFull] = useState(false);
  const color = activeTab ? activeTab.color : "#AC8CD6";
  const { url } = match;
  let itemId = selectedItem._id;

  useEffect(() => {
    const searchParams = queryString.parse(location.search);
    const { contentType, articleId, ...learningLabItem } = searchParams || {};

    setSelectedItem({
      ...learningLabItem,
      _id: articleId,
    });

    setContentType(contentType);
    fetchItem(articleId);
  }, []);

  useEffect(() => {
    setLiked(
      selectedItem.likedBy && selectedItem.likedBy.includes(authUser._id)
    );
    setLikeCount(selectedItem.likes_count);
    setShareCount(selectedItem.shares_count);
  }, [selectedItem]);

  async function fetchItem(itemId) {
    try {
      const { content } = await recordLearningLabViewCount(authToken, itemId);
      setSelectedItem(content);
    } catch (error) {}
  }

  async function handleLikeClicked() {
    if (itemId) {
      try {
        await likeLearningLabItem(authToken, itemId);
        setLikeCount(Math.max(likeCount + liked ? -1 : 1, 0));
        setLiked(!liked);
      } catch (error) {
        message.error("Failed to like lab item");
      }
    }
  }

  async function handleShareClicked() {
    history.push({
      pathname: `${url}/shareContentTo`,
      search: location.search,
    });
  }

  async function handleShareTo(selectedOption) {
    if (!selectedItem) {
      history.goBack();
      return;
    }

    const currentLocation = window.location.href;
    let articleLink =
      currentLocation.substring(0, currentLocation.indexOf("readArticle")) +
      "readArticle?";
    Object.entries(selectedItem).map(([key, value]) => {
      if (key === "_id") key = "articleId";

      if (
        [
          "articleId",
          "type",
          "title",
          "description",
          "resource",
          "videoUrl",
          "coverUrl",
          "imageUrl",
        ].includes(key)
      ) {
        if (key === "description" && value) value = value.substring(0, 60);

        articleLink += `${key}=${encodeURIComponent(value)}&`;
      }
    });

    console.log("Article link: ", articleLink);

    const shareMessage = `Check this out: ${selectedItem.title}, ${articleLink}`;

    if (selectedOption.label === "Share to RiseUp forums") {
      history.replace({
        pathname: `${url}/shareContentToForum`,
        search: location.search,
      });
    } else if (
      selectedOption.label === "Share To Twitter" ||
      selectedOption.label === "Share To Twitter"
    ) {
      history.goBack();
      const urlEnodedMessage = encodeURIComponent(
        `Check this out: ${selectedItem.title} by @RiseUpTanzania`
      );
      const twitterSharelink = `https://twitter.com/share?url=${encodeURIComponent(
        articleLink
      )}&text=${urlEnodedMessage}`;
      window.open(twitterSharelink);
    } else if (
      selectedOption.label === "Share To Facebook" ||
      selectedOption.label === "Share To Twitter"
    ) {
      history.goBack();
      const urlEnodedMessage = encodeURIComponent(
        `Check this out: ${selectedItem.title} by @RiseUpTanzania`
      );
      const facebookSharelink = `https://www.facebook.com/dialog/share?app_id=${process.env.REACT_APP_FACEBOOK_APP_ID}&display=popup&href=https://riseup.co.tz&quote=${urlEnodedMessage}`;
      window.open(facebookSharelink);
    } else if (selectedOption.label === "Share") {
      history.goBack();
      try {
        await navigator.share({
          title: selectedItem.title,
          text: shareMessage,
          url: articleLink,
        });
        message.success("Article shared succefully");
      } catch (err) {
        console.log("Failed to share lab item", err);
        message.error("Article couldn't be shared");
      }
    } else if (selectedOption.label === "Copy Article Link") {
      let link =
        currentLocation.substring(0, currentLocation.indexOf("readArticle")) +
        "readArticle?";
      link += `articleId=${selectedItem._id}`;

      history.goBack();
      copyTextToClipboard(`Check this out: ${link}`);
      console.log("Message link: ", shareMessage);
      message.success("Article link copied to clipboard");
    }

    recordShare();
  }

  async function recordShare() {
    try {
      await shareLearningLabItem(authToken, itemId);
      setShareCount(shareCount + 1);
    } catch (error) {
      console.log("Failed to share lab item", error);
    }
  }

  if (!selectedItem) return null;

  let {
    type,
    title,
    source,
    createdAt,
    description,
    resource,
    category,
  } = selectedItem;

  if (type === "article" && resource) {
    const div = document.createElement("div");
    div.innerHTML = resource;
    description = div.innerText;
  }

  return (
    <div
      id="ReadArticle"
      className="position-fixed pin-all d-flex flex-col z10"
    >
      <div className="position-relative">
        <div className="flower-deco" />

        <AuthenticatedUserToolBar
          logoIconOnly
          theme={color}
          onBack={() => history.goBack()}
        />

        {category && category[0] && category[0].name && (
          <div id="subtitle" style={{ background: lightenDarkenColor(color) }}>
            {category[0].name}
          </div>
        )}
      </div>

      <div id="ReadArticleContent" className="flex">
        {type === "video" && (
          <LearningLabItem
            item={selectedItem}
            mediaOnly
            onVideoClick={() =>
              history.push("/playYoutubeVideo/cjv-07Yw-fY", {
                modal: true,
              })
            }
          />
        )}
        <h1>{title}</h1>
        <p>
          {getHumanDiffDate(createdAt)}
          <span>&nbsp;</span>
          <div className="d-inline-flex center">
            source:{" "}
            <a
              target="_blank"
              className="brand-color-pink-text"
              href={source}
              style={{
                display: "inline-block",
                maxWidth: 190,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {source}
            </a>
          </div>
        </p>

        <div id="learningLabActions" className="d-flex">
          {likeCount !== -1 && (
            <button className="d-inline-flex" onClick={handleLikeClicked}>
              <svg fill="#e65d57" viewBox="0 0 24 24">
                {!liked && (
                  <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" />
                )}
                {liked && (
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                )}
              </svg>

              <span className="span d-flex flex-col">
                {liked ? "Liked" : "Like"}
                <small>{likeCount}</small>
              </span>
            </button>
          )}

          {shareCount !== -1 && (
            <button className="d-inline-flex" onClick={handleShareClicked}>
              <svg fill="#62d2c4" viewBox="0 0 1024 1024">
                <path d="M63.7,845C143.2,629.2,476,604.3,598,602.5v115.8c0,24.3,28.6,37.5,47.2,21.9l304.7-255.4   c13.6-11.4,13.7-32.4,0.1-43.8L645.1,185.7c-18.6-15.6-47.1-2.4-47.1,21.9v114.6C461,325.4,63.7,374.8,63.7,845z" />
                <path d="M83.1,850.3c0.9-2.5,1.9-5,2.9-7.5c0.3-0.7,0.6-1.4,0.9-2.1c0.1-0.2-1.8,4.1-0.9,2.1    c0.6-1.4,1.2-2.8,1.8-4.2c2.2-5,4.6-9.9,7.2-14.7c5-9.5,10.6-18.7,16.7-27.5c1.4-2,2.8-3.9,4.2-5.8c0.8-1,1.5-2.1,2.3-3.1    c0.7-1,2.4-2.7-1.1,1.4c0.5-0.6,0.9-1.2,1.4-1.7c3.3-4.2,6.7-8.2,10.2-12.2c7-7.9,14.5-15.5,22.4-22.6c3.9-3.6,8-7.1,12.1-10.5    c2-1.6,4-3.3,6-4.9c0.4-0.3,0.9-0.7,1.3-1c1.7-1.4-2.1,1.6-1.9,1.4c1.2-0.9,2.3-1.8,3.5-2.7c8.6-6.4,17.5-12.5,26.7-18.2    c18.4-11.5,37.6-21.5,57.4-30.3c2.4-1.1,4.9-2.1,7.3-3.2c4.4-1.9-3.3,1.3,0,0c1.4-0.6,2.8-1.2,4.2-1.7c5.1-2.1,10.3-4.1,15.4-6    c10.4-3.9,20.8-7.5,31.3-10.8c20.7-6.6,41.7-12.2,62.9-17c20.5-4.7,41.1-8.6,61.8-11.9c5-0.8,10.1-1.6,15.1-2.3    c2.4-0.3,4.8-0.7,7.2-1c0.7-0.1,1.4-0.2,2-0.3c0.4-0.1-5,0.6-2.8,0.4c1.4-0.2,2.7-0.4,4.1-0.5c9.6-1.2,19.1-2.3,28.7-3.3    c31.7-3.3,63.5-5.2,95.4-6c3.1-0.1,6.2-0.1,9.3-0.2c-6.7-6.7-13.3-13.3-20-20c0,38.5-0.6,77,0,115.4c0.3,21.7,13.5,39.4,33.8,46.6    c16.9,6,34.5,0.5,47.8-10.5c6.8-5.6,13.5-11.4,20.3-17c34.9-29.2,69.7-58.5,104.6-87.7c40.4-33.9,80.8-67.7,121.2-101.6    c14-11.8,28.1-23.6,42.1-35.3c5.7-4.8,11.6-9.3,17.1-14.4c19.7-18.4,19.8-51.8,0-70.2c-1.6-1.5-3.4-2.9-5.1-4.3    c-10-8.4-20-16.7-30-25.1c-37.8-31.7-75.6-63.4-113.4-95c-38.7-32.4-77.3-64.8-116-97.2c-11.4-9.6-22.9-19.2-34.3-28.7    c-2.2-1.9-4.4-3.7-6.7-5.6c-13.3-11-30.9-16.5-47.8-10.5c-20.3,7.2-33.5,25-33.8,46.6c-0.1,7,0,14,0,21c0,25.6,0,51.2,0,76.8    c0,5.5,0,11,0,16.4c6.7-6.7,13.3-13.3,20-20c-37.1,0.8-74.2,4.6-110.9,10.7c-46.4,7.7-92.2,19.9-135.8,37.5    C299,371.7,250,399.9,207,437c-46.5,40.1-84.3,90.4-110.3,146c-33.6,71.8-48.9,150.3-52.2,229.2c-0.5,11-0.7,21.9-0.7,32.9    c0,10.5,9.2,20.5,20,20c10.8-0.5,20-8.8,20-20c0-21.9,0.9-43.9,2.8-65.7c0.4-5.1,0.9-10.1,1.5-15.2c0.2-2.3,0.5-4.5,0.8-6.8    c0.2-1.3,0.3-2.7,0.5-4c0.1-0.9,0.2-1.8,0.3-2.7c0.3-2.2,0.2-1.8-0.2,1.3c-0.9-0.3,4.1-26,4.6-28.6c6.5-35.2,16.2-69.9,29.7-103.1    c0.6-1.5,3.6-8.1,0.8-1.9c0.8-1.7,1.5-3.4,2.2-5.1c1.8-4,3.6-8,5.5-12c3.4-7.1,6.9-14.1,10.7-21c7.4-13.6,15.5-26.9,24.3-39.6    c2.1-3,4.2-6,6.4-9c1-1.3,2-2.7,3-4c0.6-0.8,1.2-1.6,1.8-2.4c2.8-3.7-1.3,1.6-0.4,0.5c4.5-5.8,9.1-11.5,13.9-17    c9.4-10.8,19.3-21.1,29.7-30.9c9.9-9.3,20.6-17.6,30.9-26.5c-5.5,4.7-0.4,0.3,1-0.8c1.2-0.9,2.4-1.8,3.6-2.7    c2.9-2.2,5.8-4.3,8.8-6.3c5.4-3.8,10.8-7.4,16.4-11c22-14.1,45.2-26.4,69.1-36.9c1.3-0.6,2.6-1.1,3.9-1.7c0.8-0.3,1.6-0.7,2.3-1    c3.1-1.3-4.3,1.8-2.1,0.9c3-1.2,6-2.5,9-3.7c5.8-2.3,11.6-4.5,17.5-6.6c11.3-4.1,22.8-7.8,34.4-11.3c22-6.5,44.3-11.8,66.8-16    c10.3-1.9,20.7-3.7,31.1-5.2c1.1-0.2,2.2-0.3,3.3-0.5c0.7-0.1,1.3-0.2,2-0.3c2.8-0.4-3.8,0.5-3.3,0.4c2.6-0.4,5.2-0.7,7.8-1    c4.6-0.6,9.3-1.1,13.9-1.6c16.6-1.7,33.2-2.9,49.9-3.5c3.4-0.1,6.8-0.2,10.2-0.3c10.8-0.2,20-9,20-20c0-37.9-0.2-75.8,0-113.7    c0-0.7,0-1.5,0-2.2c-0.1-3.4,0,1.2-0.3,1.6c0.5-0.6,0.6-2.7,0.8-3.5c0.2-0.6,0.7-1.6,0.8-2.2c-1.3,3-1.5,3.6-0.6,1.7    c0.3-0.5,0.6-1,0.9-1.5c1.3-2.4,1.9-0.5-0.8,0.9c0.4-0.2,1.1-1.2,1.5-1.6c0.7-0.7,1.8-1.4,2.4-2.2c-2.5,3.1-2.9,2-1.4,1.2    c0.6-0.3,2.5-1.1,2.9-1.6c-0.2,0.3-4.8,1.6-1.7,0.7c0.9-0.3,1.7-0.6,2.6-0.8c0.5-0.1,1.1-0.3,1.6-0.4c2.1-0.4,1.4-0.3-2,0.3    c0.5,0.1,1.6-0.1,2.2-0.1c2.6,0,3.1,1.3-0.9-0.4c1.1,0.4,4.5,1.6,5.5,1.5c-0.6,0.1-4.3-2.3-1.6-0.6c0.7,0.5,1.8,1.3,2.6,1.6    c1.9,0.7-1.5-1.2-1.5-1.2c0.4,0.5,1,0.8,1.5,1.2c7.9,6.7,15.9,13.4,23.9,20c34.8,29.2,69.6,58.4,104.4,87.5    c39.2,32.9,78.4,65.7,117.6,98.6c19.1,16,38.5,31.6,57.2,48c0.7,0.6,1.4,1.2,2.1,1.9c0.3,0.3,0.6,0.7,0.9,1    c1.4,1.7,1.2,1.4-0.7-0.9c0.1,0,1.5,2.4,1.4,2.3c2.2,3.3-0.4-2.9-0.2-0.6c0.1,0.9,0.6,2.2,0.9,3.1c1.2,3.9,0.4-3.3-0.1-0.9    c-0.1,0.4-0.2,4.3,0,4.5c-0.4-0.3,1.2-5,0.1-1.5c-0.1,0.2-1,3.7-1.1,3.7c-0.4-0.2,2.5-4.4,0.4-1.2c-0.2,0.4-0.4,0.8-0.7,1.1    c-1,1.4-0.9,1.5,0.1,0.2c0.3-0.3,0.5-0.6,0.8-1c-0.6,0.7-1.2,1.4-1.8,2c-0.7,0.7-1.3,1.3-2,1.9c0,0-0.1,0.1-0.1,0.1    c-1.7,1.5-3.5,2.9-5.3,4.4c-10.2,8.6-20.4,17.1-30.6,25.7c-36.9,30.9-73.7,61.8-110.6,92.7c-38,31.9-76,63.7-114,95.6    c-11.6,9.7-23.3,19.5-34.9,29.2c-2.7,2.3-5.4,4.5-8.1,6.8c-0.3,0.3-0.8,0.6-1.1,0.9c1.7-2,3.1-2,1-0.9c-0.7,0.4-1.5,0.8-2.1,1.2    c-3.3,2.1,3.4-0.7,1-0.4c-0.9,0.1-1.8,0.6-2.7,0.8c-0.6,0.1-4.4,1-0.7,0.2c3.5-0.7,0.2-0.1-0.7-0.1c-0.4,0-1.7-0.2-2.2-0.1    c3.5,0.5,4.2,0.6,2,0.3c-0.7-0.1-1.4-0.3-2.1-0.5c-0.7-0.2-1.4-0.5-2.1-0.7c-3.6-1.1,3.1,2,1.3,0.5c-0.6-0.5-1.7-1-2.4-1.4    c-2.7-1.4,1.1,0.8,1.4,1.2c-0.7-0.9-2.9-3.3-3.9-3.8c2.6,1.3,2.2,3.2,0.5,0.4c-1.3-2.1-0.3-3.5,0,0.7c-0.1-0.9-1.1-4.9-1.6-5.7    c1.5,2.3,0.3,4,0.3,1.6c0,0.2,0-0.9,0-1.3c0-0.5,0-1,0-1.5c0-8,0-16.1,0-24.1c0-25,0-50,0-74.9c0-5.1,0-10.1,0-15.2    c0-10.7-9.2-20.2-20-20c-31.1,0.4-62.2,2.1-93.2,5c-41.8,3.9-83.6,9.8-124.7,18.5c-43.5,9.2-86.5,21.5-127.5,38.6    c-43.1,18-83.8,40.4-119.7,70.5C99,743.7,70.3,779.7,52.4,820.5c-2.8,6.3-5.4,12.7-7.8,19.2c-3.6,9.8,4.1,22.3,14,24.6    C69.9,866.9,79.2,860.8,83.1,850.3z" />
              </svg>

              <span className="span d-flex flex-col">
                Share
                <small>{shareCount || 0}</small>
              </span>
            </button>
          )}
        </div>

        {type !== "video" && type !== "article" && (
          <LearningLabItem item={selectedItem} type={type} mediaOnly />
        )}

        <div id="detailDescription">
          {!viewingFull && description && (
            <span>
              {`${description.substring(0, 120)}${
                description.length > 120 ? "..." : ""
              }`}
            </span>
          )}

          {viewingFull && <span>{description}</span>}

          {description && description.length > 120 && (
            <button
              className="brand-color-pink-text"
              onClick={() => setViewingFull(!viewingFull)}
            >
              {viewingFull && <span>&nbsp; </span>}
              read {viewingFull ? "less" : "more"}
            </button>
          )}
        </div>
      </div>

      <Route
        path={`${url}/shareContentTo`}
        component={(_) => (
          <BottomSheetOptions
            options={shareToOptions()}
            onOptionSelected={handleShareTo}
            onClose={() => history.goBack()}
          />
        )}
      />

      <Route
        path={`${url}/shareContentToForum`}
        component={(_) => (
          <ShareOptions
            selectedItem={selectedItem}
            onClose={(shared) => {
              if (shared) recordShare();

              history.goBack();
            }}
          />
        )}
      />
    </div>
  );
}

export default ReadArticle;

ReadArticle.propTypes = {
  authUser: PropTypes.object,
};
